module.exports = __webpack_public_path__ + "static/media/pexel-video.190a25a8.mp4";